import "./assets/index.css";

import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import { LicenseInfo } from "@mui/x-data-grid-pro";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Chart, registerables } from "chart.js";
import { AlertProvider } from "hooks/alerts/useAlert";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import theme from "./lib/theme";
import reportWebVitals from "./reportWebVitals";

import * as Sentry from "@sentry/react";
import { ConfirmationProvider } from "hooks/useConfirmation";
import { GlobalLoaderProvider } from "hooks/useGlobalLoader";
import router from "Router";

const licenseKey = process.env.REACT_APP_MUI_PRO || "";
LicenseInfo.setLicenseKey(licenseKey);

Chart.register(...registerables);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const dsn = process.env.REACT_APP_SENTRY_DSN;
if (dsn) {
  const rate = parseFloat(process.env.REACT_APP_SENTRY_SAMPLE_RATE || "1.0");
  Sentry.init({
    dsn,
    integrations: [Sentry.browserTracingIntegration()],
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: rate,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <GlobalLoaderProvider>
    <StyledEngineProvider injectFirst>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <ThemeProvider theme={theme}>
          <AlertProvider>
            <ConfirmationProvider>
              <QueryClientProvider client={queryClient}>
                <RouterProvider router={router} />
              </QueryClientProvider>
            </ConfirmationProvider>
          </AlertProvider>
        </ThemeProvider>
      </LocalizationProvider>
    </StyledEngineProvider>
  </GlobalLoaderProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
